import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EnterRoomNumberModalComponent } from 'src/app/shared/components/enter-room-number-modal/enter-room-number-modal.component';
import { LocationDragSelectModalComponent } from 'src/app/shared/components/location-drag-select-modal/location-drag-select-modal.component';
import {
  RoomModalComponent,
  RoomModalViewTypes,
} from 'src/app/shared/components/room-modal/room-modal.component';
import { Location } from '../models/project/location.model';

@Injectable({
  providedIn: 'root',
})
export class CreateCardModalManagerService {
  modalIsOpen = false;

  constructor(private modalController: ModalController) {}

  async openSearchRoomsNumberModal() {
    if (this.modalIsOpen === true) {
      return;
    }

    this.modalIsOpen = true;

    try {
      const modal = await this.modalController.create({
        component: EnterRoomNumberModalComponent,
        cssClass: 'enter-room-number-modal',
        backdropDismiss: true,
        showBackdrop: true,
      });

      modal.onDidDismiss().then((data) => {
        if (data?.data?.openGuestWithoutRoomModal === true) {
          this.openGuestWithoutRoomModalFromRoomNumberModal();
        } else if (data?.data?.openLocation) {
          this.openRoomModalAndCreateNewCardFromRoomNumberModal(data?.data?.openLocation);
        } else {
          this.modalIsOpen = false;
        }
      });

      return await modal.present();
    } catch (err) {
      this.modalIsOpen = false;
      return Promise.reject(err);
    }
  }

  private async openGuestWithoutRoomModalFromRoomNumberModal() {
    try {
      const modal = await this.modalController.create({
        component: LocationDragSelectModalComponent,
        cssClass: 'locations-drag-modal',
        backdropDismiss: true,
        showBackdrop: true,
      });
      modal.onDidDismiss().then(() => {
        this.modalIsOpen = false;
      });
      return await modal.present();
    } catch (err) {
      this.modalIsOpen = false;
      return Promise.reject(err);
    }
  }

  private async openRoomModalAndCreateNewCardFromRoomNumberModal(location: Location) {
    try {
      const modal = await this.modalController.create({
        component: RoomModalComponent,
        cssClass: 'room-modal',
        backdropDismiss: true,
        showBackdrop: true,
        componentProps: {
          object: Location.getLocationObject(location),
          subObject: Location.getLocationSubObject(location),
          zone: Location.getLocationZone(location),
          locationId: location.locationId,
          startingView: 'cards',
          openNewCard: true,
        },
      });
      modal.onDidDismiss().then(() => {
        this.modalIsOpen = false;
      });
      return await modal.present();
    } catch (err) {
      this.modalIsOpen = false;
      return Promise.reject(err);
    }
  }

  async openGuestWithoutRoomModal() {
    if (this.modalIsOpen === true) {
      return;
    }
    this.modalIsOpen = true;
    try {
      const modal = await this.modalController.create({
        component: LocationDragSelectModalComponent,
        cssClass: 'locations-drag-modal',
        backdropDismiss: true,
        showBackdrop: true,
      });
      modal.onDidDismiss().then(() => {
        this.modalIsOpen = false;
      });
      return await modal.present();
    } catch (err) {
      this.modalIsOpen = false;
      return Promise.reject(err);
    }
  }

  async openRoomModal(location: Location, viewType: RoomModalViewTypes = 'view') {
    if (this.modalIsOpen === true) {
      return;
    }
    this.modalIsOpen = true;
    try {
      const modal = await this.modalController.create({
        component: RoomModalComponent,
        cssClass: 'room-modal',
        backdropDismiss: true,
        showBackdrop: true,
        componentProps: {
          object: Location.getLocationObject(location),
          subObject: Location.getLocationSubObject(location),
          zone: Location.getLocationZone(location),
          locationId: location.locationId,
          startingView: viewType,
        },
      });
      modal.onDidDismiss().then(() => {
        this.modalIsOpen = false;
      });
      return await modal.present();
    } catch (err) {
      this.modalIsOpen = false;
      return Promise.reject(err);
    }
  }

  async dismissModal() {
    if (this.modalIsOpen) {
      await this.modalController.dismiss();
    }
  }
}
